import React from 'react';
import { ConfiguableSvgProps } from './types';

const DriftSolidIcon = ({
	width = '16',
	height = '16',
	...props
}: ConfiguableSvgProps) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6.24136 4.26233L5.49902 3.86029V10.3823L5.55098 10.4104L10.5098 13.1728V12.3468L6.24136 9.96891V4.26233Z"
				fill={props.color}
			/>
			<path
				d="M4.19922 3.86029L5.00342 4.30392V10.6234L5.0098 10.6197L9.58119 13.1663V14.0812L4.19922 11.083L4.22248 11.0697L4.19922 11.0569V3.86029Z"
				fill={props.color}
			/>
			<path
				d="M10.9299 12.8819V8.33705C10.9299 6.99358 10.1871 5.75215 8.98127 5.08041L4.1377 2.38217L5.10218 1.83087L9.97106 4.54321C11.1769 5.21495 11.9197 6.45637 11.9197 7.79984V12.3446C11.9197 13.2367 11.272 13.9124 10.4795 14.0912L10.4896 14.0424C10.7608 13.737 10.9299 13.3377 10.9299 12.8819Z"
				fill={props.color}
			/>
			<path
				d="M12.2913 12.1059V7.56117C12.2913 6.2177 11.5484 4.97627 10.3426 4.30453L5.49902 1.60629L6.46351 1.05499L11.3324 3.76733C12.5382 4.43907 13.281 5.68049 13.281 7.02396V11.5688C13.281 12.4608 12.6333 13.1365 11.8408 13.3153L11.851 13.2666C12.1221 12.9611 12.2913 12.5618 12.2913 12.1059Z"
				fill={props.color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.71484 3.19526L3.6919 2.63678L8.56077 5.34911C9.7666 6.02085 10.5094 7.26227 10.5094 8.60575V13.1505C10.5094 14.529 8.96287 15.3906 7.72564 14.7013L3.31284 12.2431L2.71484 11.9185V3.19526ZM3.70463 3.74664L7.57099 5.90051C8.77681 6.57224 9.51962 7.81366 9.51962 9.15714V13.9776C9.51962 14.2533 9.21032 14.4257 8.96287 14.2878L3.70463 11.3585V3.74664Z"
				fill={props.color}
			/>
		</svg>
	);
};

export default DriftSolidIcon;
